<template>
  <div class="padre">
    <!-- <div> -->
    <div>
      <img  :src="imageHome" align="center" class="mb-2 img-fluid" />
    </div>
    <!-- <div> -->
    <!-- <div class="hijo d-flex justify-content-center row"> -->
    <div>
      <h4>{{phraseHome}}</h4>
    </div>
  </div>
</template>

<script>
import image from "../assets/images/organicjr.jpeg";
export default {
  name: "HomePage",
  data: function () {
    return {
      loaded: false,
      imageHome: null,
      phraseHome: ''
    };
  },
  components: {},
  created : function () {
    this.loadImageHome();
  },
  computed: {
    reversedMessage: function () {
      return this.phraseHome.split('').reverse().join('');
    }
  },
  methods: {
    loadImageHome() {
      
      this.$store.dispatch("customHTTP", {
        schema: "configuracion"
      }).then( (response) => {
      })
      this.$store.dispatch("customHTTP", {
        schema: "configuracion",
        filter: {
          where: [{
            field: "payload->parametro",
            operator: "=",
            value: "imagen_inicio"
          }]
        }
      }).then( (response) => {
        if (response.data[0]) {
          this.$store.dispatch('customImageObtenerHTTP' ,{ media : response.data[0].payload.valor})
          .then( ( image ) => {
            this.imageHome = window.URL.createObjectURL( image );
            this.loadPhraseHome();
          }).catch( error => {
          });
        }
      });
    },
    loadPhraseHome() {
      this.$store.dispatch("customHTTP", {
        schema: "configuracion",
        filter: {
          where: [{
            field: "payload->parametro",
            operator: "=",
            value: "frase_inicio"
          }]
        }
      }).then( (response) => {
        if (response.data[0]) {
          this.phraseHome = response.data[0].payload.valor;
        }
      });
    }
  }
};
</script>

<style scoped>
.padre{
  padding: 0px;
  text-align: center;
  flex-direction: column;
  height: 80vmin;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .hijo{
  background: #00f;
  width: 100vmax;
  display: table-cell;
  vertical-align: middle;
  align-content: center;
} */
.fade-enter-active {
  transition: opacity 2s ease-in-out;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}
</style>
